import apiClient from "../../apiClient";

export default {
  state: {},
  actions: {
    async getMeetingById({}, id) {
      return apiClient.get(`/meetings/${id}`).then((response) => response.data);
    },
    async getMeetingVideoUrl({}, { meetingId, videoId }) {
      return apiClient
        .get(`/meetings/${meetingId}/videos/${videoId}`)
        .then((response) => response.data.url);
    },
    async getMeetingTranscriptUrl({}, id) {
      return apiClient
        .get(`/meetings/${id}/transcript`)
        .then((response) => response.data.url);
    },
    async deleteMeeting({ dispatch }, id) {
      await apiClient.delete(`/meetings/${id}`);
      return dispatch("getRooms");
    },
    shareMeetingTranscriptWithUsers({ dispatch }, { id, emailAddresses }) {
      return apiClient
        .post(`/meetings/${id}/access/grant`, {
          emailAddresses,
        })
        .then((response) => response.data);
    },
    denyMeetingTranscriptAccess({ dispatch }, { id, viewerId }) {
      return apiClient
        .post(`/meetings/${id}/access/deny/${viewerId}`)
        .then((response) => response.data);
    },
    setMeetingTranscriptPublic({}, { id, isPublic }) {
      return apiClient
        .post(`/meetings/${id}/access/public`, { isPublic })
        .then((response) => response.data);
    },
  },
};
